import React, { Component, createRef } from "react";
import {
  Breadcrumb,
  List,
  Modal,
  Form,
  Schema,
  Row,
  Col,
  Button,
  SelectPicker,
} from "rsuite";
import styled from "styled-components";
import ArrowLeftLineIcon from "@rsuite/icons/ArrowLeftLine";
import { handleSendSms } from "../scripts/helper";
import { connect } from "react-redux";
import { createStructuredSelector } from "reselect";
import { SelectedDeviceSelector } from "../redux/selector";
import listData from "../json/otherOption.json";

const Container = styled.div`
  width: 100%;
  height: 100%;
  overflow: initial;
  .rs-nav-item {
    padding-right: 6px;
    padding-left: 6px;
  }
  .rs-form-control-label {
    margin-bottom: 18px;
  }
`;
const Height = styled.div`
  height: 35%;
`;
const ListContainer = styled.div`
  width: 100%;
  height: 80vh;
  overflow: scroll;
`;
const ItemInside = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 5px;
`;
const Logo = styled.img`
  height: 30px;
  object-fit: contain;
`;

class OtherOptionComponent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showForm: false,
      formType: "temptUp",
      formValueTemptUp: {
        temp: undefined,
      },
      formValueTemptDown: {
        temp: undefined,
      },
      formValueMessage: {
        number: 1,
        text: "",
      },
    };
    this.tempUpRef = createRef();
    this.tempDownRef = createRef();
    this.customMessageRef = createRef();
  }

  handleClickOnItem = (item) => {
    const { selectedDevice } = this.props;
    if (!!item.smsBody) {
      handleSendSms(item.smsBody, selectedDevice);
    } else {
      console.log("else fire");
      console.log(item.id);
      if (item.id === 12) {
        this.setState({ showForm: true, formType: "temptUp" });
      } else if (item.id === 13) {
        this.setState({ showForm: true, formType: "temptDown" });
      } else {
        this.setState({ showForm: true, formType: "CustomMessage" });
      }
    }
  };

  handleCloseModal = () => {
    this.setState({
      showForm: false,
      formValueTemptUp: {
        temp: undefined,
      },
      formValueTemptDown: {
        temp: undefined,
      },
      formValueMessage: {
        number: 1,
        text: undefined,
      },
    });
  };

  handleSubmitCustomMessage = () => {
    const { formValueMessage: fV } = this.state;
    const { selectedDevice } = this.props;
    if (this.customMessageRef.current.check()) {
      const smsBody = `S.${fV.number}.${fV.text}`;
      handleSendSms(smsBody, selectedDevice);
    }
  };

  handleSubmitTempUp = () => {
    const { formValueTemptUp: fV } = this.state;
    const { selectedDevice } = this.props;
    if (this.tempUpRef.current.check()) {
      const smsBody = `Max.${fV.temp}`;
      handleSendSms(smsBody, selectedDevice);
    }
  };

  handleSubmitTempDown = () => {
    const { formValueTemptDown: fV } = this.state;
    const { selectedDevice } = this.props;
    if (this.tempDownRef.current.check()) {
      const smsBody = `Min.${fV.temp}`;
      handleSendSms(smsBody, selectedDevice);
    }
  };

  handleSubmitCustomMessage = () => {
    const { formValueMessage: fV } = this.state;
    const { selectedDevice } = this.props;
    if (this.customMessageRef.current.check()) {
      const smsBody = `S.${fV.number}.${fV.text}`;
      handleSendSms(smsBody, selectedDevice);
    }
  };

  render() {
    const {
      showForm,
      formType,
      formValueTemptUp,
      formValueTemptDown,
      formValueMessage,
    } = this.state;
    const { handleBack } = this.props;
    const { NumberType, StringType } = Schema.Types;

    const customMessageModel = Schema.Model({
      number: NumberType()
        .isRequired("اجباری")
        .min(1, "کمتر از ۱ نامعتبر")
        .max(4, "بیشتر از ۴ نامعتبر"),
      text: StringType().isRequired("اجباری"),
    });
    const temptUpModel = Schema.Model({
      temp: NumberType()
        .isRequired("اجباری")
        .min(0, "کمتر از صفر نامعتبر")
        .max(99, "بیشتر از ۹۹ نامعتبر"),
    });
    const temptDownModel = Schema.Model({
      temp: NumberType()
        .isRequired("اجباری")
        .min(0, "کمتر از صفر نامعتبر")
        .max(99, "بیشتر از ۹۹ نامعتبر"),
    });

    return (
      <Container>
        <Height>
          <Breadcrumb separator={<ArrowLeftLineIcon />}>
            <Breadcrumb.Item
              style={{ color: "#f07d00" }}
              onClick={() => handleBack()}
            >
              تنظیمات
            </Breadcrumb.Item>
            <Breadcrumb.Item>سایر تنظیمات</Breadcrumb.Item>
          </Breadcrumb>
        </Height>
        <ListContainer>
          <List size="sm">
            {listData.map((listItem) => (
              <List.Item
                key={listItem.id}
                index={listItem.id}
                onClick={() => this.handleClickOnItem(listItem)}
              >
                <ItemInside>
                  <small>{listItem.text}</small>
                  <Logo src={`/assets/otherOption/${listItem.logo}`} alt="🤔" />
                </ItemInside>
              </List.Item>
            ))}
          </List>
        </ListContainer>
        <Modal
          open={showForm}
          onClose={this.handleCloseModal}
          size="xs"
          style={{ maxWidth: "100%" }}
        >
          {formType === "temptUp" ? (
            <Form
              formValue={formValueTemptUp}
              onChange={(formValueTemptUp) =>
                this.setState({ formValueTemptUp })
              }
              model={temptUpModel}
              fluid
              ref={this.tempUpRef}
            >
              <Form.Group>
                <Form.ControlLabel>هشدار حد بالای دما</Form.ControlLabel>
                <Form.Control placeholder="دما" name="temp" />
              </Form.Group>
              <Form.Group>
                <Row>
                  <Col xs={12}>
                    <Button
                      onClick={this.handleSubmitTempUp}
                      block
                      appearance="primary"
                      type="submit"
                    >
                      تایید
                    </Button>
                  </Col>
                  <Col xs={12}>
                    <Button block type="button" onClick={this.handleCloseModal}>
                      لغو
                    </Button>
                  </Col>
                </Row>
              </Form.Group>
            </Form>
          ) : formType === "temptDown" ? (
            <Form
              formValue={formValueTemptDown}
              onChange={(formValueTemptDown) =>
                this.setState({ formValueTemptDown })
              }
              model={temptDownModel}
              fluid
              ref={this.tempDownRef}
            >
              <Form.Group>
                <Form.ControlLabel>هشدار حد پایین دما</Form.ControlLabel>
                <Form.Control placeholder="دما" name="temp" />
              </Form.Group>
              <Form.Group>
                <Row>
                  <Col xs={12}>
                    <Button
                      onClick={this.handleSubmitTempDown}
                      block
                      appearance="primary"
                      type="submit"
                    >
                      تایید
                    </Button>
                  </Col>
                  <Col xs={12}>
                    <Button block type="button" onClick={this.handleCloseModal}>
                      لغو
                    </Button>
                  </Col>
                </Row>
              </Form.Group>
            </Form>
          ) : (
            <Form
              formValue={formValueMessage}
              onChange={(formValueMessage) =>
                this.setState({ formValueMessage })
              }
              model={customMessageModel}
              fluid
              ref={this.customMessageRef}
            >
              <Form.Group>
                <Form.ControlLabel>تغییر متن پیام تحریک‌ها</Form.ControlLabel>
                <Row>
                  <Col xs={18}>
                    <Form.Control placeholder="متن پیام" name="text" />
                  </Col>
                  <Col xs={6}>
                    <Form.Control
                      name="number"
                      accepter={SelectPicker}
                      searchable={false}
                      cleanable={false}
                      data={[
                        { label: "یک", value: 1 },
                        { label: "دو", value: 2 },
                        { label: "سه", value: 3 },
                        { label: "چهار", value: 4 },
                      ]}
                    />
                  </Col>
                </Row>
              </Form.Group>
              <Form.Group>
                <Row>
                  <Col xs={12}>
                    <Button
                      block
                      appearance="primary"
                      type="submit"
                      onClick={this.handleSubmitCustomMessage}
                    >
                      تایید
                    </Button>
                  </Col>
                  <Col xs={12}>
                    <Button block type="button" onClick={this.handleCloseModal}>
                      لغو
                    </Button>
                  </Col>
                </Row>
              </Form.Group>
            </Form>
          )}
        </Modal>
      </Container>
    );
  }
}

const mapStateToProps = createStructuredSelector({
  selectedDevice: SelectedDeviceSelector,
});

export default connect(mapStateToProps)(OtherOptionComponent);
